/*  @flow */

import React from 'react';
import styled, { withTheme } from 'styled-components';
import Router from 'next/router';
import {
  Modal,
  Button,
  Message,
  Checkbox,
  // $FlowFixMe
} from '@bijie/react-bnb';
// $FlowFixMe
import { TwoFactor } from '@bijie/react-bnb-biz';

import TwoFALocale from '../../config/twoFALocale';
import FlexBox from '../FlexBox';
import { getLabel } from '../../utils/i18n';
import { createMarginAccount } from '../../actions/actionsSet/margin';
import { setItem } from '../../utils/localStorage';


const StyledModal = styled(Modal)`
  width: 500px !important;
  .bnc-modal-header {
    padding: 0;
    margin-bottom: -10px;
    text-align: center;
    border-bottom: none;
    color: #212833;
  }
  .bnc-modal-body {
    padding-bottom: 30px;
  }
  .checkbox-tip {
    color: #212833;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  display: flex;
  .bnc-checkbox {
    top: 1px;
  }
`;

const Title = styled.h1`
  padding-top: 15px;
  font-size: 28px;
  line-height: 37px;
  margin-bottom: 0;
`;

const MarginBox = styled.div`
  display: flex;
.img-box {
  margin:auto;
  margin-left: 20px;
  position: relative;
  width: 85px;
  height: 65px;
  float: left;
  background-image: url(${({ theme }) => theme.mode === 'DARK'
    ? require('../../static/images/margin/dark-create-account.svg')
    : require('../../static/images/margin/create-account.svg')} );
  background-position: center;
  background-repeat: no-repeat;
}
.detail-box {
  padding: 40px 0 40px 0;
  width: 516px;
  float: left;
  margin-left: 40px;
  float: left;
}
button {
  font-weight: 500;
}
.detail-box > p {
  margin-bottom: 0;
  padding: 12px 0 20px 0;
  color: ${({ theme }) => `${theme.descriptionWord}`};
}
&.column {
  .title-tip {
    padding-top: 0;
  }
  button {
    width: 100%;
  }
}
&.row {
  width: 100%;
  flex-direction: row;
  .img-box {
    position: relative;
    border-radius: 100%;
  }
  .detail-box {
    flex: 1;
    text-align: left;
    .title-tip {
      color: ${({ theme }) => `${theme.highlight} !important`};
    }
  }
}
`;

const AgreeBox = styled.div`
  max-height: 250px;
  padding: 20px;
  margin-bottom: 20px;
  color: #212833;
  font-size: 12px;
  border: 1px solid #eaecef;
  overflow-y: auto;
`;
const allWidth = { width: '100%' };

type Props = {
  i18n: Object,
  mode: string,
  locale: string,
  isKYCValidated: boolean,
  userKYCInfo: Object,
  mobileSecurity: boolean,
  gauth: boolean,
};
type States = {
  agreeStatus: boolean,
  showConfirmModal: boolean,
  isShow2FAModal: boolean,
}

export default
@withTheme
class CreateMarginAccount extends React.Component<Props, States> {
  static defaultProps = {
    i18n: {},
    mode: 'column',
    userKYCInfo: {},
    isKYCValidated: false,
  }

  state = {
    showConfirmModal: false,
    agreeStatus: false,
    isShow2FAModal: false,
  }

  _handleArgee = () => {
    this.setState(({ agreeStatus }) => ({ agreeStatus: !agreeStatus }));
  }

  _handleAgreeCancel = () => {
    this.setState({
      showConfirmModal: false,
    });
  }

  _creaeAccount = async () => {
    const { agreeStatus } = this.state;
    const { locale = 'en', i18n } = this.props;
    if (!agreeStatus) return;
    try {
      await createMarginAccount();
      setItem(window.localStorage, 'createMarginAccountSymbol', true);
      Router.push(`/${locale}/usercenter/wallet/balances?tab=margin`);
    } catch (error) {
      const msg = error.message.split(',').reduce((cur, next) => cur + getLabel(next, i18n), '');
      Message.fail(msg);
    }
  }

  _showModal = () => {
    const {
      mobileSecurity, gauth,
    } = this.props;
    if (!mobileSecurity && !gauth) {
      this.setState({
        isShow2FAModal: true,
      });
      return;
    }
    this.setState({
      showConfirmModal: true,
    });
  }

  render() {
    const { i18n, locale, mode } = this.props;
    const { showConfirmModal, agreeStatus, isShow2FAModal } = this.state;
    const tutorialUrl = locale === 'cn' ?
      'https://www.binance.vision/zh/tutorials/binance-margin-trading-guide' : ' https://www.binance.vision/tutorials/binance-margin-trading-guide';
    return (
      <FlexBox justify="start" align="center">
        <MarginBox className={mode}>
          <div className="img-box" />
          <div className="detail-box">
            <Title className="title-tip">{getLabel('exchange-CreateMarginAccount-ImportantReminder', i18n)}</Title>
            <p>{getLabel('exchange-CreateMarginAccount-ReminderContent', i18n)}</p>
            <Button
              id="CreateMarginAccount-button-OpenMarginAccount"
              size={mode === 'row' ? 'md' : 'lg'}
              type="primary"
              onClick={this._showModal}
            >
              {getLabel('exchange-CreateMarginAccount-OpenMarginAccount', i18n)}
            </Button>
            <p>
              <a target="_blank" rel="noopener noreferrer" href={tutorialUrl} style={{ color: '#f0b90b' }}>
                {getLabel('exchange-CreateMarginAccount-marginTutorial', i18n)}
              </a>
            </p>
          </div>
        </MarginBox>
        <StyledModal
          centered={true}
          visible={showConfirmModal}
          onCancel={this._handleAgreeCancel}
          title={<Title>{getLabel('exchange-CreateMarginAccount-MarginAccountAgreement', i18n)}</Title>}
          footer={
            <Button
              id="CreateMarginAccount-button-OpenAccount"
              size="lg"
              type="primary"
              style={allWidth}
              disabled={!agreeStatus}
              onClick={this._creaeAccount}
            >
              {getLabel('exchange-CreateMarginAccount-OpenAccount', i18n)}
            </Button>
            }
        >
          <AgreeBox>
            {getLabel('exchange-CreateMarginAccount-marginVerification', i18n)}
          </AgreeBox>
          <StyledCheckbox checked={agreeStatus} onChange={this._handleArgee} className="checkbox-tip">
            {getLabel('exchange-CreateMarginAccount-understandAndAgree', i18n)}
          </StyledCheckbox>
        </StyledModal>
        <TwoFactor.Modal
          visible={isShow2FAModal}
          autoFocus={true}
          google={false}
          mobile={false}
          enable={{
            locale: TwoFALocale(i18n).enable,
            onSkip: () => this.setState({ isShow2FAModal: false }),
            onGoogleJump: () => Router.push(`/${locale}${TwoFALocale(i18n).enable.enableGooglePath}`),
            onSmsJump: () => Router.push(`/${locale}${TwoFALocale(i18n).enable.enableSmsPath}`),
          }}
          onOk={val => console.log(val)}
        />
      </FlexBox>
    );
  }
}
